<template>
  <div>
    <div class="opo02">
      <span class="opo03">版本列表</span>
    </div>
    <div class="opo01">
      <div class="djt30">
<!--        <div class="djt31">-->
<!--          <input v-model="searchs" type="text" placeholder="输入商品名称进行搜索" placeholder-class="djt32" class="djt33">-->
<!--          <img @click="seas" src="@/assets/images/sea01.png" alt="" class="djt34">-->
<!--        </div>-->
      </div>
      <div style="width: 50%;display: flex;justify-content: flex-end">
        <!--        <div class="djt02" style="margin-right: 20px" @click="xjsp">-->
        <!--          <img src="@/assets/images/qw2.png" class="djt03" alt="">-->
        <!--          <p class="djt04">新建商品</p>-->
        <!--        </div>-->
        <div class="djt02" @click="addVer">
          <img src="@/assets/images/xinz01.png" class="djt03" alt="">
          <p class="djt04">新增版本</p>
        </div>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt26" style="width: 10%">版本号</div>
        <div class="djt26" style="width: 65%">地址</div>
        <div class="djt26" style="width: 15%">时间</div>
        <div class="djt26" style="width: 10%">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data.dataList" :key="'lis'+index">
            <div class="djt27g2" style="width: 10%" :title="item.version">{{item.version}}</div>
            <div class="djt27g2" style="width: 65%" :title="item.url">
              <a target="_blank" style="text-decoration:underline;" :href="item.url">{{item.url}}</a>
            </div>
            <div class="djt27g2" style="width: 15%" :title="item.ctime">{{item.ctime}}</div>
            <div class="djt28g2" style="width: 10%">
<!--              <img src="@/assets/images/qw7.png" v-if="item.isup == 2" @click="sxj(item)" title="下架" class="djy16" alt="" >-->
<!--              <img src="@/assets/images/qw8.png" v-else title="上架" @click="sxj(item)" class="djy16" alt="" >-->
              <img src="@/assets/images/del01.png" title="删除版本信息" @click="toDel(item)" class="djy16" alt="" style="margin-left: 20px">
            </div>
          </div>
        </template>
      </el-skeleton>
      <div class="djt09" style="border-bottom: none;margin-top: 5px;">
        <el-pagination
          @current-change="toPage"
          background
          :page-size="8"
          :page-count="data.totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination>
      </div>
    </div>
    <xc-model :loading="isModel" title="新增版本" :is_buttom="false" @cancel="cancel">
      <div slot="mbody">
        <div class="djt17">
          <div class="djt18">
            <div class="djt19">版本号：</div>
            <input v-model="vers" type="text" placeholder="请输入版本号" class="djt20">
          </div>
<!--          <div class="apks01" style="position:relative;">-->
<!--            <div class="apks02">-->
<!--              <p class="apks03">选择版本文件</p>-->
<!--            </div>-->
<!--            -->
<!--          </div>-->
          <div style="width: 100%;display: flex;justify-content: center">
            <Upload
              ref="upload"
              class="vers01"
              :on-success="succGz"
              :multiple="false"
              :default-file-list="lists"
              type="drag"
              action="/load/gyy/api/uploadfile">
              <div>
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或者拖拽以上传版本文件</p>
              </div>
            </Upload>
          </div>
          <div class="djt21">
            <div class="djt22" @click="addVers" :class="[isDis == true?'disSty':'']">确认</div>
            <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
          </div>
        </div>
      </div>
    </xc-model>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  export default {
    name: "djgver",
    data(){
      return{
        searchs:'',
        isModel:false,
        loading:true,
        pageSize:7,
        page:1,
        data:[],
        vers:'',
        urls:'',
        lists:[],
        isDis:true,
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      let data = {
        page:1,
        pageSize:me.pageSize,
      }
      httpUser.getdeviceversionlist(data).then(res =>{
        console.log(res);
        me.data = res.data;
        me.loading = false;
      })
    },
    methods:{
      addVers(){//点击确定添加版本
        if (me.vers == '' || me.vers.indexOf(' ') != -1) {
          me.$message.error('请正确输入版本号');
          return false;
        }
        if (me.urls == '') {
          me.$message.error('请先上传文件');
          return false;
        }
        if (me.isDis == true) {
          return false;
        }
        me.$Loading.start();
        let data = {
          version:me.vers,
          url:me.urls
        }
        httpUser.adddeviceversion(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                page:me.page,
                pageSize:me.pageSize,
              }
              httpUser.getdeviceversionlist(data).then(res =>{
                me.data = res.data;
                me.isModel = false;
                me.$Loading.finish();
                me.$message.success('已添加版本');
                setTimeout(function () {
                  me.vers = '';
                  me.urls = '';
                  me.$refs.upload.clearFiles();
                },500)
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('稍后再试');
              break;
          }
        })
      },
      succGz(e){//文件上传成功后的钩子
        me.urls = e.data;
        me.isDis = false;
        console.log(e);
      },
      addVer(){//点击新增版本信息按钮
        me.isModel = true;
      },
      toDel(item){//删除版本信息
        me.$confirm('是否删除该版本?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          me.$Loading.start();
          let data = {
            id:item.id,
          }
          httpUser.deldeviceversion(data).then(res => {
            switch (res.code) {
              case "0000":
                let data = {
                  page:me.page,
                  pageSize:me.pageSize,
                }
                httpUser.getdeviceversionlist(data).then(res => {
                  me.data = res.data;
                  me.$Loading.finish();
                  me.$message.success('已删除该版本');
                })
                break;
              case "1111":
                me.$Loading.error();
                me.$message.error('请稍后再试');
                break;
            }
          })
        }).catch(() => {
        });
      },
      seas(){
        me.$Loading.start();
        let data = {
          keyword:me.searchs,
          page:1,
          pageSize:me.pageSize,
        }
        if (user.companyId != '1') {
          me.$set(data,'companyid',user.companyId);
        }
        httpUser.getgoodslist(data).then(res => {
          me.$Loading.finish();
          me.data = res.data;
        })
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          page:e,
          pageSize:me.pageSize,
        }
        me.page = e;
        httpUser.getdeviceversionlist(data).then(res => {
          me.data = res.data;
          me.loading = false;
          console.log(res);
        })
      },
      cancel(){//添加框点击返回
        me.isModel = false;
        setTimeout(function () {
          me.vers = '';
          me.urls = '';
          me.$refs.upload.clearFiles();
        },500)
      },
    }
  }
</script>

<style scoped>
@import "djgver.css";
</style>